import classNames from 'classnames';

type StandardTableSubHeaderProps = {
  setSort: (value: string) => void;
  sort: string;
  sortDirection: 'asc' | 'desc';
  label: string;
  value: string;
  title?: string;
  bandClass?: string;
  withLeftDivider?: boolean;
};

const ChevronUp = () => (
  <svg
    aria-hidden="true"
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 4.5L4 1.5L7 4.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const ChevronDown = () => (
  <svg
    aria-hidden="true"
    width="8"
    height="6"
    viewBox="0 0 8 6"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M1 1.5L4 4.5L7 1.5"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

const SortGlyph = ({
  isActive,
  direction
}: {
  isActive: boolean;
  direction: 'asc' | 'desc';
}) => {
  if (isActive) {
    return (
      <span className="inline-flex text-primary-600">
        {direction === 'asc' ? <ChevronUp /> : <ChevronDown />}
      </span>
    );
  }
  return (
    <span className="inline-flex flex-col gap-[1px] text-neutral-300 group-hover/sort:text-neutral-400 transition-colors">
      <ChevronUp />
      <ChevronDown />
    </span>
  );
};

const StandardTableSubHeader = ({
  setSort,
  sort,
  sortDirection,
  label,
  value,
  title,
  bandClass,
  withLeftDivider
}: StandardTableSubHeaderProps) => {
  const isActive = sort === value;
  const direction: 'asc' | 'desc' = sortDirection;

  return (
    <th
      scope="col"
      title={title}
      className={classNames(
        'group/sort px-3 py-2.5 text-center align-bottom select-none',
        'border-b border-neutral-200',
        bandClass,
        withLeftDivider && 'border-l border-neutral-200',
        isActive ? 'text-primary-700' : 'text-neutral-600'
      )}
    >
      <button
        type="button"
        onClick={() => setSort(value)}
        className={classNames(
          'mx-auto inline-flex items-center gap-1.5',
          'text-[11px] font-semibold uppercase tracking-[0.06em]',
          'transition-colors hover:text-primary-700',
          'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-300 focus-visible:rounded'
        )}
      >
        <span className="whitespace-nowrap">{label}</span>
        <SortGlyph isActive={isActive} direction={direction} />
      </button>
    </th>
  );
};

export default StandardTableSubHeader;
